import * as Sentry from '@sentry/react';
import routes from 'app/components/csrRoutesConfig';
import {matchPath} from 'react-router';
import sentryBeforeSendHandler from 'app/services/sentry/beforeSendHandler';
import {ignoreErrorMessage} from 'app/helpers/sentryIgnoreErrors';
import {COLORS} from '@fupa/fupa-uikit';

let sentryInitialized = false;
const initSentry = () => {
  if (process.env.ENVIRONMENT === 'local' || sentryInitialized) {
    return;
  }
  sentryInitialized = true;
  // From https://github.com/getsentry/sentry-javascript/issues/3388
  const isAffectByIssue3388 = navigator?.userAgent?.includes('Chrome/74.0.3729');
  Sentry.init({
    dsn: 'https://ce9aabc2bf3c4a4d89d5dab11455e6bd@sentry.io/1808824',
    denyUrls: [/grumi-ip\.js/, /\/gtm\.js/, /\/tag\.min\.js/, /\/gtag\/js/], // exclude known 3rd party urls from tracking
    allowUrls: [
      // capture events only for domain fupa to avoid tracking issues e.g. occurred with ads
      /^https:\/\/([a-z0-9-]*\.)?fupa\.(net|rocks|dev)/,
    ],
    environment: process.env.ENVIRONMENT,
    release: process.env.SENTRY_RELEASE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.browserApiErrorsIntegration({requestAnimationFrame: !isAffectByIssue3388}),
      Sentry.reactRouterV5BrowserTracingIntegration({
        history,
        routes,
        matchPath,
      }),
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ['fupa-app-sentry-key'],
        behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
      }),
      Sentry.feedbackAsyncIntegration({
        autoInject: false,
        submitButtonLabel: 'Senden',
        formTitle: 'Teile uns deine Meinung mit 💬',
        triggerLabel: 'Feedback geben',
        addScreenshotButtonLabel: 'Bildschirmfoto hinzufügen',
        removeScreenshotButtonLabel: 'Bildschirmfoto entfernen',
        confirmButtonLabel: 'Bestätigen',
        cancelButtonLabel: 'Abbrechen',
        successMessageText: 'Danke für dein Feedback!',
        messagePlaceholder: 'Was können wir verbessern? Möchtest du ein Problem melden?',
        messageLabel: 'Dein Feedback',
        isRequiredLabel: '(erforderlich)',
        showName: false,
        showEmail: false,
        showBranding: false,
        colorScheme: 'light',
        themeLight: {
          background: COLORS.white,
          accentBackground: COLORS.fupaSecondary,
        },
      }),
    ],
    beforeSend: sentryBeforeSendHandler,
    tracesSampleRate: 0.0005,
    tracePropagationTargets: [/^https:\/\/www\.fupa\.net/, /^https:\/\/api\.fupa\.net/],
    profilesSampleRate: 1.0, // all traces are profiled -> tracesSampleRate * profilesSampleRate = 0.001 of all transactions are profiled
    ignoreErrors: ignoreErrorMessage,
  });
};

export default initSentry;
